import { render, staticRenderFns } from "./ChartDashboardView.vue?vue&type=template&id=541df22c"
import script from "./ChartDashboardView.vue?vue&type=script&lang=js"
export * from "./ChartDashboardView.vue?vue&type=script&lang=js"
import style0 from "./ChartDashboardView.vue?vue&type=style&index=0&id=541df22c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports